module.exports = __webpack_public_path__ + "static/media/eye.e1480f9d.svg";